import { Helmet } from 'react-helmet-async';
import Footer from './Footer';
import HomeContainer from './HomeContainer';
import Banner from './Banner';
import ProductList from './ProductList';
import Nav from './Nav';
import Banner2 from './Banner2';

export default function DDMHome() {
    return (
        <>
            <Helmet>
                <title>DDM Live 도매몰</title>
                <meta name="og:title" content="FLOWING SHOP"></meta>
                <meta name="description" content="FLOWING SHOP"></meta>
                <meta name="og:description" content="FLOWING SHOP"></meta>
            </Helmet>
            <HomeContainer>
                <Nav />
                <Banner2 />
                <ProductList />
                <Footer />
            </HomeContainer>
        </>
    );
}
